var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('notifications'),_vm._v(" "),_c('section',{staticClass:"section"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('div',{key:_vm.$route.fullPath},[_c('header-page'),_vm._v(" "),_vm._t("default")],2)])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }